<template>
  <div role="document">
    <section id="intro" class="container px-4 my-4">
      <div class="row">
        <div class="col-lg-12 px-lg-12 py-lg-12">
          <h1>Pronunce della Corte Costituzionale</h1>
          <p>
            In questa pagina puoi consultare tutte le pronunce della Corte Costituzionale navigando la tabella qui sotto.
            Ricordati che puoi fare una ricerca mirata <a href="#" data-toggle="modal" data-target="#modalsearch"> cliccando qui</a> oppure sul pulsante di ricerca in alto a destra.
          </p>
        </div>
      </div>
    </section>
    <DocumentsList ref="documentsListComponent" />
  </div>
</template>

<script>
import Document from '@/components/pages/Document';
import DocumentsList from '@/components/imports/DocumentsList';

export default {
  name: 'pronunce',
  components: {
    Document,
    DocumentsList,
  },
  breadcrumb: {
    label: 'Pronunce',
    parent: 'home',
  },
  data() {
    return {
    };
  },
};
</script>

<style lang="scss" scoped>
</style>






// WEBPACK FOOTER //
// src/components/pages/Pronunce.vue